export const exportHeaders = [
    {
        label: "Loyalty Id",
        key: "loyalty_id"
    },
    {
        label: "Customer Account Number",
        key: "shipto"
    },
    {
        label: "Customer Billto Account Number",
        key: "billto",
    },
    {
        label: "PMA Type",
        key: "pma_type",
    },
    {
        label: "Privilege Code",
        key: "privilege_code"
    },
    {
        label: "Contract Code",
        key: "contract_code"
    },
    {
        label: "Loyalty",
        key: "loyalty"
    },
    {
        label: "System Managed",
        key: "system_managed",
    },
    {
        label: "Billto status",
        key: "billto_status",
    },
    {
        label: "Shipto Status",
        key: "shipto_status",
    }


]